<template>
  <div class="body" v-if="show">
    <div class="header">
      <a class="logo" href="javascript:;" @click="$router.push({path:'/'})">
        <img src="../assets/img/logo.svg" alt/>
      </a>
      <!-- <a class="menu_btn" href="javascript:;" @click="$router.push('more')">
        <img src="../assets/img/menu.png" alt/>
      </a> -->
    </div>
    <div class="box"></div>
    <div class="title-bj">
      <div class="title">{{ detail.title }}</div>
      <div class="priceBox">
        <span
          class="span"
        >会议时间：{{ startTime.slice(0, startTime.length - 8) }}~ {{ endTime.slice(0, endTime.length - 8) }}</span>
        <!-- <span v-if="detail.fareType == 0" class="TicketPrice">票价：￥{{detail.fare}}</span> -->
        <!-- <span v-if="detail.fareType == 1" class="TicketPrice">定金：￥{{detail.fare}}</span> -->
        <span class="span">地点：{{ detail.region }}</span>
      </div>
    </div>

    <div class="section">公司名称</div>
    <div class="inp">
      <input
        class="boder"
        placeholder="请输入公司名称"
        v-model.trim="name"
				type="search"
				id="inputId"
				autocomplete="off"
        @blur="animateWidth()"
        @input="handleSearch($event)"
				@compositionstart="onCompositionStart"
				@compositionend="onCompositionEnd"/>
				<div v-if="showCom&&comList&&comList.length>0" class="inp_com">
					<div v-for="(item, index) in comList" :key="item.id" @click="selectCom(index)">{{ item.enName }}</div>
				</div>
    </div>

    <div class="section">票种选择</div>
    <span v-for="(item, index) in ticketData" :key="index">
      <div :class="['stamp', {'stamp_border': item.checked}]">
        <div @click="click(index)">
          <img v-if="item.checked" class="icon" src="/static/image/icon_selected.png" alt="">
          <div class="stamp_header">
            <div>
              <span>{{ item.name }}</span>
              <span class="tip">
                <span v-if="item.discountType == 0">同时享受</span>
                <span v-else>享受最优惠</span>
              </span>
            </div>

            <div :class="[{'icon_stamp': item.checked}]">
              <template v-if="item.curPrice&&item.curPrice>0">
                <span class="t1">￥<span>{{ item.price | toCalc(item.number, item.price) }}</span></span>
                &nbsp;
                <span class="t2">￥<span>{{ item.curPrice ? item.curPrice : item.price }}</span></span>
              </template>
              <template v-else>
                <span class="t2">￥<span>{{ item.curPrice ? item.curPrice : item.price }}</span></span>
              </template>
            </div>
          </div>
          <div class="stamp_content">
						<div class="meal" v-if="ticketData[index].mealCouponName!=null">
							<div>餐券</div>
							<span>{{ticketData[index].mealCouponName}}</span>
						</div>
            <div v-for="(el, k) in item.discountList" :key="k">
              <div>{{ el.typeStr }}</div>
              <span>{{ el.noteStr }}</span><span class="yh">{{ el.discountStr }}</span>
            </div>
          </div>
        </div>
        <div>
          <div class="stamp_footer">
            <span>购买票数</span>
            <span>
              <a @click="reduce(index)" :class="[{'disabled': item.number == 1}]">－</a>
              <input type="number" v-model="item.number" @input="numInput($event, index)" disabled>
              <a @click="plus(index)"> + </a>
            </span>
          </div>

          <div class="person">
            <div v-for="(n, idx) in item.ticketList" :key="idx" @click="selPerson(idx, index)">
              <input v-model="n.name" type="text" placeholder="添加参会人信息">
              <img src="../assets/img/ic_arrow.png" alt="">
            </div>
          </div>
        </div>
      </div>
    </span>

    <!-- <div class="inp">
      <input
        class="boder"
        placeholder="请输入报名人数"
        type="tel"
        v-model.trim="people"
        @blur="animateWidth()"
        @input="change(people)"
      />
    </div> -->
    <!-- <div class="tip">
      提示：{{discountInfo}}
      <span class="vip">(尊敬的会员用户，请登录势银app享受会员专享优惠)</span>
    </div> -->
    <div class="p">
      <div class="remark" v-html="detail.remark"></div>
    </div>
    <div class="btnBox"></div>
    <div class="btn">
      <div class="total">合计：￥{{ totalFare | toFixed }}</div>
      <div class="discount">优惠：￥{{ preferentialAmount | toFixed }}</div>

      <div class="button" v-if="hasSubmit">请稍等</div>
      <div class="button" @click="btn" v-else>报名</div>
    </div>

    <!-- 底部弹框 -->
    <div :class="{'container': showPopup}" @click="cancelPopup"></div>
    <div :class="['popup', {'popup-show': showPopup, 'popup-hide': !showPopup}]">
      <div class="section">请填写参会人的信息</div>
      <div :model="model" class="form">
        <div>
          <P><span> * </span>姓 名</P>
          <input type="text" v-model="model.name" placeholder="请输入姓名">
        </div>
        <div>
          <P><span> * </span>电 话</P>
          <input type="text" v-model="model.phone" placeholder="请输入电话号码">
        </div>
        <div>
          <P><span> * </span>职 位</P>
          <input type="text" v-model="model.companyDuty" placeholder="请输入职位">
        </div>
        <div>
          <P><span> * </span>邮箱</P>
          <input type="text" v-model="model.emailAddress" placeholder="请输入邮箱" @blur="formatEmail">
        </div>
        <div>
					<button @click="deletePopup" class="delete">删 除</button>
					<button @click="submitPopup" class="primary">确 定</button>
				</div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  Toast
} from 'mint-ui'

export default {
  data () {
    return {
      name: '',
      enId: '',
      people: '',
      detail: '',
      enroll: '',
      startTime: '',
      endTime: '',
      show: '',
      discountInfo: '',
      monthbigsmall: '',
      nowDate: '',
      finalResult: '',
      apiTicketReqestDTO: {},
      preferentialAmount: 0,
      totalFare: 0,
      ticketData: [],
      showPopup: false,
      model: {
        name: '',
        phone: '',
        companyDuty: '',
        emailAddress: ''
      },
      comList: [],
      showCom: true,
      hasSubmit: false,
      lock: false
    }
  },
  watch: {
    // $route () {},
    // 'people': function (newVal) {
    //   this.totalFare = this.detail.fare * this.people
    // }
  },
  created () {
    this.content()
    this.timeNow()
  },
  mounted () {},
  filters: {
    toCalc (num, val) {
      if (num > 0) {
        return num * val
      }
      return val
    },
    toFixed (val) {
      if (val != null && val != '') { return val.toFixed(1) }
      return '0.0'
    }
  },
  methods: {
    formatEmail (event) {
      this.model.emailAddress = event.target.value.replace(/\s*/g, '')
    },
    onCompositionStart () {
      this.lock = true
    },
    onCompositionEnd (e) {
      // 输入中文触发
      this.lock = false
      // 在调用
      this.handleSearch(e)
    },
    handleSearch (e) {
      // 正常输入 中文不触发
      if (!this.lock) {
        const value = e.target.value.replace(/\s*/g, '')
        this.$axios
				  .get(`/api/web/phone/conference/enterpriseWithContentId?enName=${value}`, {})
				  .then(res => {
				    this.comList = res.data.enterpriseList
				    this.showCom = !!(this.comList && this.comList.length > 0)
				    if (this.comList.length == 0 || this.comList.length > 1) {
				      this.enId = ''
				    } else {
				      this.enId = this.comList[0].id
				    }
				  })
      }
    },
    selectCom (index) {
      this.name = this.comList[index].enName
      this.enId = this.comList[index].id
      this.content()
    },
    click (n, type) {
      this.ticketData[n].checked = !this.ticketData[n].checked
      this.ticketData.splice(n, 1, this.ticketData[n])
      this.calcTicket(n, this.ticketData[n])
    },
    reduce (n) {
      if (this.ticketData[n].number > 1) {
        this.ticketData[n].number--
        this.ticketData[n].ticketList.pop()
      }
      this.calcTicket(n, this.ticketData[n])
    },
    plus (n) {
      // if (!this.ticketData[n].checked) {
      //   this.Toast("请先选择票种");
      //   return;
      // }
      this.ticketData[n].number++
      this.ticketData[n].ticketList.push({
        name: '',
        phone: '',
        companyDuty: '',
        emailAddress: ''
      })
      this.calcTicket(n, this.ticketData[n])
    },
    numInput (evt, n) {
      const value = evt.target.value
      this.ticketData[n].number = Math.floor(value)
      this.calcTicket(n, this.ticketData[n])
    },
    // 计算票价
    calcTicket (n, target) {
      this.$axios
        .get(`/api/web/phone/enrollTicket/countDiscount?ticketId=${target.id}&number=${target.number}`, {})
        .then(res => {
          if (res.code == 200) {
            this.ticketData[n].curPrice = res.data
            this.ticketData.splice(n, 1, this.ticketData[n])

            let totalFare = 0
            let preferentialAmount = 0
            this.ticketData.map(el => {
              if (el.curPrice && el.checked) {
                totalFare = totalFare + el.curPrice
                preferentialAmount += el.price * el.number - el.curPrice
              }
            })
            this.totalFare = totalFare
            this.preferentialAmount = preferentialAmount
            console.log(totalFare, preferentialAmount)
          }
        })
    },
    animateWidth () {
      setTimeout(() => {
        const scrollHeight =
          document.documentElement.scrollTop || document.body.scrollTop || 0
        window.scrollTo(0, Math.max(scrollHeight - 1, 0))
        this.showCom = false
      }, 100)
    },
    // handleChange(evt, index) {
    //   this.ticketData[index].checked = !this.ticketData[index].checked
    //   this.totalFare = 0
    //   this.preferentialAmount = 0
    //   this.ticketData.map(el => {
    //     if (el.checked && el.number > 0) {
    //       this.totalFare += el.curPrice
    //       this.preferentialAmount += (el.price * el.number - el.curPrice)
    //     }
    //   })
    // },
    selPerson (idx, index) {
      this.model.idx = idx
      this.model.index = index
      Object.assign(this.model, this.ticketData[index].ticketList[idx])
      this.showPopup = true
    },
    cancelPopup () {
      this.model = {}
      this.showPopup = false
    },
    deletePopup () {
      const {idx, index} = this.model
      this.ticketData[index].number--
      this.ticketData[index].ticketList.splice(idx, 1)
      this.calcTicket(index, this.ticketData[index])
      this.showPopup = false
    },
    submitPopup () {
      const {idx, index} = this.model
      if (this.model.name == '') {
        Toast('请填写姓名')
        return
      }
      if (this.model.phone == '') {
        Toast('请填写电话号码')
        return
      } else {
        let reg = /^\d{11}$/
        let patt = /^[1][3-9][\d]{9}/
        this.model.phone = this.model.phone.trim()

        if (!reg.test(this.model.phone) || !patt.test(this.model.phone)) {
          Toast('请填写正确的电话号码')
          return
        }
	  }
      if (this.model.companyDuty == '') {
        Toast('请填写职位')
        return
      }
      if (this.model.emailAddress == '') {
        Toast('请填写邮箱')
        return
      }
      // if (!this.verify.mobile(this.model.phone, '电话号码格式错误'))
      //   return;
      // if (this.model.emailAddress.length > 0 && !this.verify.isEmail(this.model.emailAddress, '邮箱格式错误'))
      //   return;

      // let hasPhoneIndex = -1;
      // for (let t of this.ticketData) {
      //   hasPhoneIndex = t.ticketList.findIndex(item => item.phone === this.model.phone);
      //   if (hasPhoneIndex > -1) {
      //     Toast(this.model.phone + ' 该手机号已存在')
      //     return;
      //   }
      // }

      Object.assign(this.ticketData[index].ticketList[idx], this.model)
      this.showPopup = false
    },
    content () {
      this.$axios
        .get(`api/web/phone/enrollTicket/getTickets/${this.$route.query.contentId}`, {})
        .then(res => {
          if (res.code == 200) {
            this.ticketData = res.data
            this.ticketData.map(el => {
              el.number = 1
              el.checked = false
              el.ticketList = [{
                name: '',
                phone: '',
                companyDuty: '',
                emailAddress: ''
              }]
              let eIdx = 0, mIdx = 0
              el.discountList.map((elem, index) => {
                if (elem.type == 2) {
                  elem.show = eIdx == 0
                  eIdx++
                } else if (elem.type == 3) {
                  elem.show = mIdx == 0
                  mIdx++
                }
              })
            })
            // console.log('ticketData', this.ticketData)
          }
        })
      this.$axios
        .post(`api/web/phone/content/detail/${this.$route.query.contentId}`, {})
        .then(res => {
          this.detail = res.data
          this.endTime = res.data.endTime
          this.startTime = res.data.startTime
          localStorage.setItem('detail', JSON.stringify(this.detail))
          let txt = ''
          this.detail.ticketDiscountList.map(e => {
            txt += e.discountInfo
          })
          this.discountInfo = txt
          this.show = true
        })
      const fenxiangdizhi = window.location.href.replace('signup', 'detail')
      this.wxShare(
        this.detail.title,
        this.detail.description,
        this.detail.thumbApp,
        fenxiangdizhi
      )
      // if (localStorage.getItem('names')) {
      //   this.name = localStorage.getItem('names')
      // }
    },
    change (val) {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        if (this.compareDate(this.startTime, this.nowDate)) {
          this.discount(val, this.DateDiff(this.startTime.slice(0, this.startTime.length - 8)))
        } else {
          this.discount(val, this.DateDiff(this.nowDate))
        }
      }, 300)
    },
    btn () {
      let peopleList = []
      let index = 0
      this.ticketData.forEach(item => {
        item.ticketList.forEach(ticket => {
          peopleList.push({
            id: ++index,
            iphone: ticket.phone,
            job: ticket.companyDuty,
            email: ticket.emailAddress,
            name: ticket.name
          })
        })
      })

      localStorage.setItem('msg', JSON.stringify(peopleList))
      localStorage.setItem('peoples', this.people)
      localStorage.setItem('names', this.name)

      this.confrom()
    },

    confrom () {
      const formData = {
        conferenceId: this.detail.contentId,
        organization: this.name,
        members: 0,
        ticketList: [],
        enId: this.enId
      }
      const {ticketData} = this
      for (let el in ticketData) {
        if (ticketData[el].number > 0) {
          formData.members += parseInt(ticketData[el].number)

          const ticketList = ticketData[el].ticketList.filter(e => e.name != '')
          if (ticketList.length > 0) {
            formData.ticketList.push({
              ticketId: ticketData[el].id,
              attendees: []
            })
          }
          if (ticketList.length == 0 && ticketData[el].checked) {
            Toast('请填写参会人信息')
            return
          } else {
            for (let elem in ticketList) {
              if (ticketList[elem].name == '') {
                // Toast('请填写参会人信息');
                // return;
              } else {
                formData.ticketList[formData.ticketList.length - 1].attendees.push(ticketList[elem])
                // delete elem.idx
                // delete elem.index
                if (ticketList[elem].idx) this.delKey(ticketList[elem], 'idx', 'index')
              }
            }
          }
        }
      }
      if (formData.members == 0) {
        Toast('请先选择购买票数')
        return
      }
      console.log('formData', formData)
      // return

      if (formData.organization == '') {
        this.MessageBox.alert('请填写公司名称').then(action => {
        })
        return
      }
      if (formData.ticketList.length == 0) {
        this.MessageBox.alert('请选择票种').then(action => {
        })
        return
      }

      localStorage.setItem('apiTicketReqestDTO', JSON.stringify(this.apiTicketReqestDTO = {
        ticketCount: formData.members,
        // ticketFare: this.preferentialAmount,
        totalFare: parseFloat(this.totalFare).toFixed(2),
        discount: this.preferentialAmount
      }))

      // return
      const enroll = {
        conferenceId: this.detail.contentId,
        organization: this.name,
        members: formData.members
      }

      // 调用报名接口
      this.createEnroll(formData)
    },
    createEnroll (formData, opt) {
      this.hasSubmit = true
      let url = '/api/web/phone/conference/newEnroll'
      if (opt && opt != '') {
        url += '?opt=1'
      }
      this.$axios.postJson(url, formData).then(res => {
        if (res.code == 200) {
          localStorage.setItem('enrollId', res.data.id)
          if (res.data.haveSurvey) {
            this.$router.push({
              path: `/questionnaire`,
              query: {
                contentId: this.$route.query.contentId,
                categoryId: this.$route.query.categoryId,
                parentId: this.$route.query.parentId
              }
            })
          } else {
            this.$router.push({
              path: `/msg`,
              query: {
                contentId: this.$route.query.contentId,
                categoryId: this.$route.query.categoryId,
                parentId: this.$route.query.parentId
              }
            })
          }
        } else if (res.code == 1217) {
          this.MessageBox.confirm(res.message).then(action => {
            if (action == 'confirm') {
              this.createEnroll(formData, 1)
            }
          })
        } else {
          this.MessageBox.alert(res.message).then(action => {
          })
        }
      }).finally(() => {
        this.hasSubmit = false
      })
    },
    // 人数优惠数组排序
    compare (a, b) {
      return a - b
    },
    // 获取当前时间
    timeNow (sDate1) {
      var date = new Date()
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var day = date.getDate()
      if (month < 10) {
        month = '0' + month
      }
      if (day < 10) {
        day = '0' + day
      }
      this.nowDate = year + '/' + month + '/' + day
    },
    // 计算相差月份
    DateDiff (sDate1) {
      var aDate, oDate1, oDate2, iDays
      aDate = sDate1.split('-')
      oDate1 = new Date(aDate[1] + '/' + aDate[2] + '/' + aDate[0]) // 转换为9-25-2017格式
      aDate = this.nowDate.split('-')
      oDate2 = new Date(aDate[1] + '/' + aDate[2] + '/' + aDate[0])
      iDays = parseInt(Math.abs(oDate1 - oDate2) / 1000 / 60 / 60 / 24 / 30) // 把相差的毫秒数转换为天数
      return iDays
    },
    // 比较日期大小
    compareDate (date1, date2) {
      date1 = new Date(date1)
      date2 = new Date(date2)
      if (date1.getTime() > date2.getTime()) {
        return true
      } else {
        return false
      }
    },
    // 优惠规则计算
    discount (num, mon) {
      num = String(num)
      mon = String(mon)
      // eslint-disable-next-line one-var
      const presonMin = [],
        presonMax = [],
        presonDis = [],
        monthMin = [],
        monthDis = []
      let obj = JSON.stringify(this.detail.ticketDiscountList)
      let objnew = JSON.parse(obj)
      objnew.map((e, i) => {
        e.discountRule = e.discountRule.split(',')
        if (e.discountRule[0] == '0') {
          presonMin.push(e.discountRule[1])
          presonMax.push(e.discountRule[2])
          presonDis.push(e.discountRule[3])
        } else {
          monthMin.push(e.discountRule[1])
          monthDis.push(e.discountRule[2])
        }
      })
      let presonResult
      const newdata = presonMin.sort(this.compare)
      if (presonMin.length !== 0) {
        presonMin.map((e, i) => {
          // debugger
          if (num >= e && num <= presonMax[i]) {
            presonResult = i
          } else {
            if (num < newdata[0]) {
              presonResult = '无人数优惠'
            } else if (num >= newdata[newdata.length - 1]) {
              presonResult = presonMax.length - 1
            }
          }
        })
      } else {
        presonResult = '无人数优惠'
      }

      let monthResult
      if (monthMin.length !== 0) {
        monthMin.map((e, i) => {
          if (mon >= e) {
            monthResult = i
          } else {
            monthResult = '无时间优惠'
          }
        })
      } else {
        monthResult = '无时间优惠'
      }

      if (presonResult == '无人数优惠') {
        presonResult = 1
      } else {
        presonResult = presonDis[presonResult] / 10
      }
      if (monthResult == '无时间优惠') {
        monthResult = 1
      } else {
        monthResult = monthDis[monthResult] / 10
      }
      let finalResult
      if (presonResult < monthResult) {
        finalResult = presonResult
      } else {
        finalResult = monthResult
      }
      this.finalResult = finalResult
      console.log('finalResultfinalResultfinalResult', this.finalResult)
      if (finalResult == 1) {
        this.preferentialAmount = 0
      } else {
        let discountNum = this.finalResult == 1 ? 0 : (this.detail.fare * this.people) - (this.detail.fare * this.people * this.finalResult)
        discountNum = discountNum.toFixed(2)
        this.preferentialAmount = discountNum
      }
    },
    delKey (obj, ...args) {
      args.forEach(v => {
        delete obj[v]
      })
      return obj
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/sass/global.scss";
</style>
<style lang="scss" scoped>

.vip {
  color: rgb(255, 0, 0);
}

.tip {
  font-size: 12px;
  font-weight: 300;
  color: #fff;
  margin-left: 5px;
  padding: 1.5px;
  text-align: left;
  background: rgba(250, 116, 43, 0.8);
  border-radius: 2px;
}

.priceBox {
  position: relative;
}

.TicketPrice {
  position: absolute;
  font-size: 12px;
  top: 0;
  right: 0;
}

.title-bj {
  padding: 26px;
  margin: 22px 12px;
  min-height: 68px;
  background: url("../assets/img/dingdan_bg@3x.png");
  background-size: 100% 100%;
}

.span {
  text-align: left;
  font-size: 12px;
  display: block;
  margin-top: 8px;
}

.title {
  text-align: left;
  font-weight: 700;
  // padding: 26px 26px 0 26px;
  font-size: 16px;
}

.btnBox {
  width: 100%;
  height: 72px;
  // position: fixed;
  bottom: 5px;
}

.btn {
  display: flex !important;
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 72px;
  line-height: 72px;
  box-sizing: border-box;
  -moz-box-sizing: border-box; /* Firefox */
  -webkit-box-sizing: border-box; /* Safari */
  display: block;
  background: url("../assets/img/jiage_BG@2x.png");
  background-size: 100% 100%;
  justify-content: space-around;
  z-index: 1;

  .button {
    color: #fff;
    width: 104px;
    height: 38px;
    font-size: 15px;
    line-height: 38px;
    background-image: linear-gradient(38deg, #FFE985 0%, #FA742B 100%);
    // box-shadow: 0 3px 9px 0 #9cdbff;
    border-radius: 25px;
    margin-top: 15px;
  }

  .total {
    font-size: 16px !important;
    color: #666666;
  }

  .discount {
    font-size: 12px !important;
    color: #9F9F9F;
  }
}

.inp {
  height: 42px;
  text-align: left;
  margin: 20px 21px;
  background: #f6f6f6;
  border-radius: 7px;

  input {
    height: 100%;
    line-height: normal;
    color: #797979;
    width: 90%;
    -webkit-tap-highlight-color: transparent;
    padding-left: 16px;
    font-size: 14px;
  }
}

.inp_com {
  width: 83.5%;
  max-height: 200px;
  background: #f6f6f6;
  z-index: 999;
  position: absolute;
  overflow: scroll;
  border-radius: 5px;
  padding: 5px 10px;
  margin-right: 21px;

  div {
    font-size: 14px;
    padding: 5px;
  }
}

.section, .stamp {
  text-align: left;
  margin: 5.333vw 5.6vw;
  font-weight: bold;
}

.section {
  font-size: 14px;
  padding-left: 5px;
  border-left: 4px solid #4a90e2;
}

.stamp_border {
  border-width: 2px!important;
}
.stamp {
  border: 1px solid #4a90e2;
  background: #f6f9fe;
  border-radius: 5px;
  padding: 10px;

  .stamp_header, .stamp_footer {
    justify-content: space-between;
    display: flex;
  }

  .icon {
    width: 30px;
    height: 30px;
    right: 21px;
    float: right;
    position: absolute;
    margin-top: -11px;
  }

  .disabled {
    color: #f3f3f3;
  }

  .icon_stamp {
    margin-right: 20px;
  }

  .stamp_header {
    div {
      font-size: 14px;
    }

    div:nth-child(2) {
      span {
        font-size: 12px;

        span {
          font-size: 4.267vw;
        }
      }

      .t1 {
        color: #d7d7d9;
        span {
          text-decoration: line-through;
        }
      }

      .t2 {
        color: #ff0000 !important;
        span {
          color: #ff0000;
        }
      }
    }
  }

  .stamp_content {
    margin-bottom: 10px;
    border-bottom: 1px solid #d4e4f8;
    padding-bottom: 10px;
		.meal {
			display: flex;
			align-items: center;
		}

    div {
      display: flex;
      margin-top: 5px;

      .show {
        visibility: hidden;
      }

      div {
        color: #4a90e2;
        border: 1px solid #4a90e2;
        border-radius: 2px;
        font-size: 12px;
        font-weight: 300;
        height: 4.4vw;
      }

      span {
        color: #aeafb2;
        margin: 5px 8px 0;
        font-size: 12px;
        height: 24px;
        line-height: 24px;
        font-weight: 400;
      }

      .yh {
        position: absolute;
        right: 20px;
        color: #FF0000;
      }
    }

    .tip {
      margin: 0;

      span {
        color: #FA742B;
        font-size: 12px;
        border: 1px solid #FA742B;
        border-radius: 5px;
        margin: 10px 0 0;
        padding: 0 2px;
      }
    }
  }

  .stamp_footer {
    font-size: 14px;
    display: flex;

    span {
      line-height: 24px;
      height: 24px;
    }

    span:nth-child(2) {
      color: #222222;
      background: #fff;
      border: 1px solid #f3f3f3;
      padding: 0 5px;
      border-radius: 5px;

      input {
        width: 40px;
        text-align: center;
        border: 1px solid #f3f3f3;
        border-style: none solid;
      }
    }
  }

  .person {
    margin-top: 15px;

    div {
      display: flex;
      padding-bottom: 10px;
      margin-bottom: 15px;
      justify-content: space-between;
      border-bottom: 1px solid #f3f3f3;

      input {
        font-size: 14px;
      }

      img {
        width: 20px;
        height: 20px;
      }
    }
  }
}

.popup {
  width: 100%;
  // height: 48%;
  position: fixed;
  bottom: 0;
  padding-bottom: 24px;
  background: #fff;
  z-index: 999;
  border-radius: 20px 20px 0 0;

  .form {
    padding: 0 20px;

    div {
      display: flex;
			justify-content: space-around;
      height: 42px;
      line-height: 42px;
      border-bottom: 1px solid #f3f3f3;
			margin-bottom: 10px;

      P {
        width: 100px;
        text-align: left;
        padding-right: 15px;
        color: #2c3e50;

        span {
          color: #FF0000;
        }
      }
    }
		button {
			width: 45%;
			height: 40px;
			color: #fff;
			border: none;
			border-radius: 20px;
			margin-top: 32px;
			font-size: 14px;
		}
    .primary {
      background: #71c4f1;
    }
		.delete {
			background: #EB595F;
		}
  }
}

.popup-show {
  transition: all 0.3s ease;
  transform: translateY(0);
}

.popup-hide {
  transition: all 0.3s ease;
  transform: translateY(100%);
}

.container {
  height: 100%;
  position: fixed;
  z-index: 99;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
}

/* 使用webkit内核的浏览器 */
::-webkit-input-placeholder {
  color: #9f9f9f;
  line-height: normal;
  padding-top: 0.06rem;
}

/* Firefox版本4-18 */
:-moz-placeholder {
  color: #9f9f9f;
  padding-top: 0.06rem;
}

/* Firefox版本19+ */
::-moz-placeholder {
  color: #9f9f9f;
  padding-top: 0.06rem;
}

/* IE浏览器 */
:-ms-input-placeholder {
  color: #9f9f9f;
  padding-top: 0.06rem;
}

.p {
  margin: 9px 10px 0;
  font-size: 12px;
}

.box {
  height: 56px;
}

.body {
  // position: fixed;
  width: 100%;
  height: 100%;
  background-color: #fff;
  // background: #fff;
  // min-height: 100vh;
  // box-sizing: border-box;
  // position: relative;
  // overflow: auto;
}

.header {
  height: 54px;
  background: #ffffff;
  border-bottom: 2px solid #f5f5f5;
  top: 0;
  left: 0;
  right: 0;
  position: fixed;
  z-index: 99;

  .logo {
    display: inline-block;
    // width: 133px;
    // height: 38px;
    position: absolute;
    top: 10px;
    left: 15px;

    img {
      height: 35px;
    }
  }

  .menu_btn {
    display: inline-block;
    position: absolute;
    top: 13px;
    right: 13px;
    width: 29px;
    height: 29px;
    -webkit-tap-highlight-color: transparent;

    img {
      width: 100%;
      height: 100%;
    }
  }
}

.signup {
  font-weight: 700;
  font-family: PingFangSC-Medium;
  font-size: 17px;
  color: #232323;
  letter-spacing: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/singup.vue